export default __webpack_public_path__ + "static/media/Blacksorrow.2b8bb04e.jpg";